import { Route, Routes } from "react-router-dom";

// layout imports
import AuthLayout from "./layouts/AuthLayout";
import BasicLayout from "./layouts/BasicLayout";

import AboutUs from "./pages/AboutUs";
import NotFound from "./pages/NotFound";
import Login from "./pages/Login/Login";
import Contact from "./pages/Contact";
import Authentication from "./pages/Authentication/Authentication";
import ForgotPassword from "./pages/ForgotPassword";
import Services from "./pages/Services";
import Technology from "./pages/Technology";
import Home from "./pages/Home";
import HealthOrganisations from "./pages/HealthOrganisation/HealthOrganisations";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import ChangePassword from "./pages/ChangePassword/ChangePassword";
import AddHealthOrganisation from "./pages/HealthOrganisation/AddHealthOrganisation";
import HealthOrganisationDetails from "./pages/HealthOrganisation/HealthOrganisationDetails";
import EditHealthOrganisation from "./pages/HealthOrganisation/EditHealthOrganisation";
import Laboratories from "./pages/Laboratory/Laboratories";
import AddLaboratory from "./pages/Laboratory/AddLaboratory";
import LaboratoryDetails from "./pages/Laboratory/LaboratoryDetails";
import EditLaboratory from "./pages/Laboratory/EditLaboratory";
import ViewSpecimens from "./pages/Specimen/ViewSpecimens";
import SpecimenForm from "./pages/Specimen/SpecimenForm";
import Specimens from "./pages/Specimen/Specimens";
import Users from "./pages/User/Users";
import UserRoles from "./pages/User/UserRoles";
import Nurses from "./pages/Nurse/Nurses";
import AddNurse from "./pages/Nurse/AddNurse";
import UserRoleDetails from "./pages/User/UserRoleDetails";
import EditUserRole from "./pages/User/EditUserRole";
import UserDetails from "./pages/User/UserDetails";
import AddUser from "./pages/User/AddUser";
import Admin from "./pages/Admin/Admin";
import AddAdmin from "./pages/Admin/AddAdmin";
import AdminDetails from "./pages/Admin/AdminDetails";
import EditAdmin from "./pages/Admin/EditAdmin";
import UserList from "./pages/User/UserList";
import EditUser from "./pages/User/EditUser";
import AddUserTab from "./pages/User/AddUserTab";
import SpecimenDetails from "./pages/Specimen/SpecimenDetails";
import Surgeons from "./pages/Surgeon/Surgeons";
import SurgeonDetails from "./pages/Surgeon/SurgeonDetails";
import AddSurgeon from "./pages/Surgeon/AddSurgeon";
import OperatingTheatres from "./pages/OperatingTheatre/OperatingTheatres";
import OperatingTheatreDetails from "./pages/OperatingTheatre/OperatingTheatreDetails";
import AddOperatingTheatre from "./pages/OperatingTheatre/AddOperatingTheatre";
import EditOperatingTheatre from "./pages/OperatingTheatre/EditOperatingTheatre";
import NurseDetails from "./pages/Nurse/NurseDetails";
import EditNurse from "./pages/Nurse/EditNurse";
import Specialities from "./pages/Speciality/Specialities";
import SpecialityDetails from "./pages/Speciality/SpecialityDetails";
import AddSpeciality from "./pages/Speciality/AddSpeciality";
import EditSpeciality from "./pages/Speciality/EditSpeciality";
import TestTypes from "./pages/TestType/TestTypes";
import TestTypeDetails from "./pages/TestType/TestTypeDetails";
import AddTestType from "./pages/TestType/AddTestType";
import EditTestType from "./pages/TestType/EditTestType";
import Procedures from "./pages/Procedure/Procedures";
import ProcedureDetails from "./pages/Procedure/ProcedureDetails";
import AddProcedure from "./pages/Procedure/AddProcedure";
import EditProcedure from "./pages/Procedure/EditProcedure";
import Organs from "./pages/Organ/Organs";
import AddOrgan from "./pages/Organ/AddOrgan";
import EditOrgan from "./pages/Organ/EditOrgan";
import Sites from "./pages/Site/Sites";
import AddSite from "./pages/Site/AddSite";
import EditSite from "./pages/Site/EditSite";
import Lesions from "./pages/Lesion/Lesions";
import AddLesion from "./pages/Lesion/AddLesion";
import EditLesion from "./pages/Lesion/EditLesion";
import MetadataList from "./pages/Metadata/MetadataList";
import AddMetadata from "./pages/Metadata/AddMetadata";
import EditMetadata from "./pages/Metadata/EditMetadata";
import ClinicalDiagrams from "./pages/ClinicalDiagram/ClinicalDiagrams";
import ClinicalDiagramDetails from "./pages/ClinicalDiagram/ClinicalDiagramDetails";
import AddClinicalDiagram from "./pages/ClinicalDiagram/AddClinicalDiagram"
import EditClinicalDiagram from "./pages/ClinicalDiagram/EditClinicalDiagram";
import Courier from "./pages/Courier/Courier";
import AddCourier from "./pages/Courier/AddCourier";
import CourierDetails from "./pages/Courier/CourierDetails";
import EditCourier from "./pages/Courier/EditCourier";
import DiscrepantSpecimens from "./pages/DiscrepantSpecimen/DiscrepantSpecimens";
import ViewDiscrepantSpecimens from "./pages/DiscrepantSpecimen/ViewDiscrepantSpecimens";
import DiscrepantSpecimenForm from "./pages/DiscrepantSpecimen/DiscrepantSpecimenForm";
import DiscrepantSpecimenDetails from "./pages/DiscrepantSpecimen/DiscrepantSpecimenDetails";
import RFDownload from "./pages/RFDownload/RFDownload";
import RFDetails from "./pages/RFDownload/RFDetails";
import SpecimenTracking from "./pages/SpecimenTracking/SpecimenTracking";
import SpecimenTimelineDetails from "./pages/SpecimenTracking/SpecimenTimelineDetails";
import RequireSuperAdmin from "./components/RequireSuperAdmin";

// Main App component
const App = () => {
  return (
    // BrowserRouter provides the navigation context for the app
    // {/* Routes component manages the application's routing */}
    <Routes>
      {/* Route for pages with the AuthLayout (non-authenticated pages) */}
      <Route element={<AuthLayout />}>
        <Route path="/" element={<Services />} />
        <Route path="/technology" element={<Technology />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/login" element={<Login />} />
        <Route path="/resetpassword" element={<ResetPassword />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/authentication" element={<Authentication />} />
        <Route path="/changepassword" element={<ChangePassword />} />
      </Route>
      {/* Routes for pages with BasicLayout */}
      <Route element={<BasicLayout />}>
        <Route path="/home" element={<Home />} />
        <Route path="/health-organisations" element={<HealthOrganisations />} />
        <Route path="/health-organisations/add" element={<AddHealthOrganisation />} />
        <Route path="/health-organisations/details/:id" element={<HealthOrganisationDetails />} />
        <Route path="/health-organisations/edit/:id" element={<EditHealthOrganisation />} />
        <Route path="/laboratories" element={<Laboratories />} />
        <Route path="/laboratories/add" element={<AddLaboratory />} />
        <Route
          path="/laboratories/details/:id"
          element={<LaboratoryDetails />}
        />
        <Route path="/laboratories/edit/:id" element={<EditLaboratory />} />
        <Route path="/users" element={<Users />} />
        <Route path="/users/:id" element={<UserList />} />
        <Route path="/users/details/:id" element={<UserDetails />} />
        <Route path="/users/edit/:id" element={<EditUser />} />
        <Route path="/user/add-tab" element={<AddUserTab />} />
        <Route path="/user/roles" element={<UserRoles />} />
        <Route path="/user/roles/details/:id" element={<UserRoleDetails />} />
        <Route path="/user/roles/edit/:id" element={<EditUserRole />} />
        <Route path="/user/add" element={<AddUser />} />

        <Route path="/nurses" element={<Nurses />} />
        <Route path="/nurses/add" element={<AddNurse />} />
        <Route path="/nurses/details/:id" element={<NurseDetails />} />
        <Route path="/nurses/edit/:id" element={<EditNurse />} />

        {/* Admin routes  */}
        <Route path="/admins" element={<Admin />} />
        <Route path="/admins/add" element={<AddAdmin />} />
        <Route path="/admins/details/:id" element={<AdminDetails />} />
        <Route path="/admins/edit/:id" element={<EditAdmin />} />

        <Route path="/specimens" element={<Specimens />} />
        <Route path="/specimens/view/:id" element={<ViewSpecimens />} />
        <Route path="/specimens/form/:id" element={<SpecimenForm />} />
        <Route path="/specimens/details/:id" element={<SpecimenDetails />} />

        <Route
          path="/specimen-tracking"
          element={
            <RequireSuperAdmin>
              <SpecimenTracking />
            </RequireSuperAdmin>
          }
        />
        <Route
          path="/specimen-tracking/timeline/:id"
          element={
            <RequireSuperAdmin>
              <SpecimenTimelineDetails />
            </RequireSuperAdmin>
          }
        />

        <Route path="/surgeons" element={<Surgeons />} />
        <Route path="/surgeons/details/:id" element={<SurgeonDetails />} />
        <Route path="/surgeons/add" element={<AddSurgeon />} />

        <Route path="/operating-theatres" element={<OperatingTheatres />} />
        <Route
          path="/operating-theatres/details/:id"
          element={<OperatingTheatreDetails />}
        />
        <Route
          path="/operating-theatres/add"
          element={<AddOperatingTheatre />}
        />
        <Route
          path="/operating-theatres/edit/:id"
          element={<EditOperatingTheatre />}
        />

        {/* Reference data — Super Admin only. Route-guarded because nav
            visibility alone is bypassable by typing the URL directly. */}
        <Route
          path="/specialities"
          element={
            <RequireSuperAdmin>
              <Specialities />
            </RequireSuperAdmin>
          }
        />
        <Route
          path="/specialities/details/:id"
          element={
            <RequireSuperAdmin>
              <SpecialityDetails />
            </RequireSuperAdmin>
          }
        />
        <Route
          path="/specialities/add"
          element={
            <RequireSuperAdmin>
              <AddSpeciality />
            </RequireSuperAdmin>
          }
        />
        <Route
          path="/specialities/edit/:id"
          element={
            <RequireSuperAdmin>
              <EditSpeciality />
            </RequireSuperAdmin>
          }
        />

        <Route
          path="/test-types"
          element={
            <RequireSuperAdmin>
              <TestTypes />
            </RequireSuperAdmin>
          }
        />
        <Route
          path="/test-types/details/:id"
          element={
            <RequireSuperAdmin>
              <TestTypeDetails />
            </RequireSuperAdmin>
          }
        />
        <Route
          path="/test-types/add"
          element={
            <RequireSuperAdmin>
              <AddTestType />
            </RequireSuperAdmin>
          }
        />
        <Route
          path="/test-types/edit/:id"
          element={
            <RequireSuperAdmin>
              <EditTestType />
            </RequireSuperAdmin>
          }
        />
        <Route
          path="/procedures"
          element={
            <RequireSuperAdmin>
              <Procedures />
            </RequireSuperAdmin>
          }
        />
        <Route
          path="/procedures/details/:id"
          element={
            <RequireSuperAdmin>
              <ProcedureDetails />
            </RequireSuperAdmin>
          }
        />
        <Route
          path="/procedures/add"
          element={
            <RequireSuperAdmin>
              <AddProcedure />
            </RequireSuperAdmin>
          }
        />
        <Route
          path="/procedures/edit/:id"
          element={
            <RequireSuperAdmin>
              <EditProcedure />
            </RequireSuperAdmin>
          }
        />
        <Route
          path="/organs"
          element={
            <RequireSuperAdmin>
              <Organs />
            </RequireSuperAdmin>
          }
        />
        <Route
          path="/organs/add"
          element={
            <RequireSuperAdmin>
              <AddOrgan />
            </RequireSuperAdmin>
          }
        />
        <Route
          path="/organs/edit/:id"
          element={
            <RequireSuperAdmin>
              <EditOrgan />
            </RequireSuperAdmin>
          }
        />
        <Route
          path="/sites"
          element={
            <RequireSuperAdmin>
              <Sites />
            </RequireSuperAdmin>
          }
        />
        <Route
          path="/sites/add"
          element={
            <RequireSuperAdmin>
              <AddSite />
            </RequireSuperAdmin>
          }
        />
        <Route
          path="/sites/edit/:id"
          element={
            <RequireSuperAdmin>
              <EditSite />
            </RequireSuperAdmin>
          }
        />
        <Route
          path="/lesions"
          element={
            <RequireSuperAdmin>
              <Lesions />
            </RequireSuperAdmin>
          }
        />
        <Route
          path="/lesions/add"
          element={
            <RequireSuperAdmin>
              <AddLesion />
            </RequireSuperAdmin>
          }
        />
        <Route
          path="/lesions/edit/:id"
          element={
            <RequireSuperAdmin>
              <EditLesion />
            </RequireSuperAdmin>
          }
        />
        <Route
          path="/metadata"
          element={
            <RequireSuperAdmin>
              <MetadataList />
            </RequireSuperAdmin>
          }
        />
        <Route
          path="/metadata/add"
          element={
            <RequireSuperAdmin>
              <AddMetadata />
            </RequireSuperAdmin>
          }
        />
        <Route
          path="/metadata/edit/:id"
          element={
            <RequireSuperAdmin>
              <EditMetadata />
            </RequireSuperAdmin>
          }
        />
        <Route
          path="/clinical-diagrams"
          element={
            <RequireSuperAdmin>
              <ClinicalDiagrams />
            </RequireSuperAdmin>
          }
        />
        <Route
          path="/clinical-diagrams/details/:id"
          element={
            <RequireSuperAdmin>
              <ClinicalDiagramDetails />
            </RequireSuperAdmin>
          }
        />
        <Route
          path="/clinical-diagrams/add"
          element={
            <RequireSuperAdmin>
              <AddClinicalDiagram />
            </RequireSuperAdmin>
          }
        />
        <Route
          path="/clinical-diagrams/edit/:id"
          element={
            <RequireSuperAdmin>
              <EditClinicalDiagram />
            </RequireSuperAdmin>
          }
        />

        <Route path="/discrepant-specimens" element={<DiscrepantSpecimens />} />
        <Route path="/discrepant-specimens/view/:id" element={<ViewDiscrepantSpecimens />} />
        <Route path="/discrepant-specimens/form/:id" element={<DiscrepantSpecimenForm />} />
        <Route path="/discrepant-specimens/details/:id" element={<DiscrepantSpecimenDetails />} />

        <Route path="/rf-download" element={<RFDownload />} />
        <Route path="/rf-details" element={<RFDetails />} />

        <Route
          path="/couriers" element={<Courier />}
        />
        <Route
          path="/couriers/add" element={<AddCourier />}
        />
        <Route path="/couriers/details/:id" element={<CourierDetails />} />
        <Route path="/couriers/edit/:id" element={<EditCourier />} />
      </Route>
      {/* Route for handling 404 errors */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

// Export the App component as the default export
export default App;
